import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  Inject
} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material";
import { FormGroup, FormBuilder, Validators, FormArray } from "@angular/forms";
import { ToastService } from "ng-uikit-pro-standard";
import { ActivatedRoute, Router } from "@angular/router";
import { AppConfig } from "src/app/config";
import { DataService } from "src/app/data.service";
import { TranslationService } from "src/app/translation.service";

interface IDialogData {
  name: string;
  displayname: string;
  editdisplayname: string;
  fieldhistory: boolean;
  approvalhistory: boolean;
  team: boolean;
  pathsetting: boolean;
  activity: boolean;
  notesandattachments: boolean;
  processbartype: string;
  followup: boolean;
  mode: string;
  category: string;
  devicetype: string;
  sinceversionseq: number;
  deprecatedversionseq: number;
}

@Component({
  selector: "app-properties-dialog",
  templateUrl: "./properties-dialog.component.html",
  styleUrls: ["./properties-dialog.component.scss"]
})
export class PropertiesDialogComponent implements OnInit {
  // @Output() openDialog: EventEmitter<any> = new EventEmitter<any>();
  @Output() openTranslateDialog: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  // translatingDialog(): void {
  //   console.log("Test");
  //   this.openDialog.emit(true);
  // }

  translatingDialog(value: string): void {
    console.log("Translating:", value);
    this.openTranslateDialog.emit(true);
  }

  mode = "";
  metaobjectId: any;
  metaobjectName: any;
  metaLayoutGroupId: any;
  detailForm: FormGroup;
  @Input() closable = false;
  @Input() visible: boolean = true;
  @Output() enteredNameEvent: EventEmitter<string> = new EventEmitter<string>();
  @Output() viewNameEvent: EventEmitter<string> = new EventEmitter<string>();

  displayName: string;
  editDisplayName: string;

  isLoading: boolean;
  languages: any[];
  errorMessage: any;
  isError: boolean;
  translatedLabels: any;
  datas: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IDialogData,
    private dialogRef: MatDialogRef<PropertiesDialogComponent>,
    private formBuilder: FormBuilder,
    private toastrService: ToastService,
    private router: Router,
    private route: ActivatedRoute,
    private appConfig: AppConfig,
    private dataService: DataService,
    public dialog: MatDialog,
    private translationService: TranslationService
  ) {}

  translateForm: FormGroup;

  CategorySelect = [
    { value: "DEFAULT", label: "DEFAULT" },
    { value: "COMPACT", label: "COMPACT" },
    { value: "MOBILE", label: "MOBILE" }
  ];

  DeviceTypeSelect = [
    { value: "WEB", label: "WEB" },
    { value: "MOBILE", label: "MOBILE" }
  ];
  ngOnInit() {
    console.log("data", this.data);
    this.detailForm = this.formBuilder.group({
      displayname: [this.data.displayname, Validators.required],
      editdisplayname: [this.data.editdisplayname, Validators.required],
      name: [this.data.name, Validators.required],
      fieldhistory: [this.data.fieldhistory],
      approvalhistory: [this.data.approvalhistory],
      activity: [this.data.activity],
      notesandattachments: [this.data.notesandattachments],
      followup: [this.data.followup],
      team: [this.data.team],
      pathsetting: [this.data.pathsetting],
      processbartype: [this.data.processbartype],
      category: [this.data.category],
      devicetype: [this.data.devicetype],
      sinceversionseq: [
        this.data.sinceversionseq != null ? this.data.sinceversionseq : 0
      ],
      deprecatedversionseq: [
        this.data.deprecatedversionseq != null
          ? this.data.deprecatedversionseq
          : 0
      ]
    });
    this.mode = this.data.mode;
    // this.route.queryParams.subscribe((params) => {
    //   this.mode = this.route.snapshot.params.mode;
    //   this.metaobjectId = this.route.snapshot.params.metaobjectid;
    //   this.metaobjectName = this.route.snapshot.params.metaobjectname;
    //   this.metaLayoutGroupId = this.route.snapshot.params.metagroupid;
    // });

    // console.log("mode", mode);
    // console.log("mode", this.route);
    this.translateForm = this.formBuilder.group({
      translate: this.formBuilder.array([]),
      code: "",
      language: ""
    });

    // Initialize with one language by default
    this.addLang();
    this.getLanguage();
    // this.getTranslationLabelById();
  }

  getLanguage() {
    // alert(id)
    const organizationid = localStorage.getItem("crm_orgid");
    const domain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.domain`
    );
    const subdomain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.subdomain`
    );

    this.isLoading = true;
    this.dataService
      .getOrgLanguage(organizationid, domain, subdomain)
      .subscribe(
        (res) => {
          // alert('****res****' + JSON.stringify(res));
          console.log(res);
          if (res !== null && res.success == 1) {
            var allLanguages = res.data.orglanguage;
            var objArr = [];
            //just add an empty entry sice this field is optional
            objArr.push({ value: "", label: "--None--" });
            for (let i = 0; i < allLanguages.length; i++) {
              objArr.push({
                value: allLanguages[i].code,
                label: allLanguages[i].language
              });
            }
            this.languages = objArr;

            this.isLoading = false;
          } else {
            console.log("error while deleting");
            this.isLoading = false;
            this.showError(res.message);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          this.showError(err.message);
        }
      );
  }

  selectedLanguageChange(event: { value: string; label: any }) {
    console.log("selectedLanguageChange", event);
    if (event.value.trim() != "") {
      this.translateForm.controls["code"].setValue(event.value);
      this.translateForm.controls["language"].setValue(event.label);
    } else {
      this.translateForm.controls["code"].setValue("");
      this.translateForm.controls["language"].setValue("");
    }
  }

  translatedText: string = "";

  get translate(): FormArray {
    return this.translateForm.get("translate") as FormArray;
  }

  addLang() {
    const translateGroup = this.formBuilder.group({
      languageCode: ["", Validators.required],
      translatedName: ["", Validators.required]
    });

    this.translate.push(translateGroup);
  }

  translator(index: number) {
    const translateGroup = this.translate.at(index) as FormGroup;
    const selectedLanguage = translateGroup.get("languageCode").value;
    const labelname = this.datas.labelname;

    console.log(selectedLanguage);

    this.translationService
      .translate(labelname, selectedLanguage, "en")
      .subscribe((response: any) => {
        const translatedText = response.data.translations[0].translatedText;
        translateGroup.get("translatedName").setValue(translatedText);
      });
  }
  saveTranslated() {
    // console.log(this.translateForm);
    if (this.translateForm.valid) {
      // Handle the form submission
      console.log("Saving form data:", this.translateForm.value.translate);

      this.translatedLabels = this.translateForm.value.translate;
    }
    this.dialogRef.close();
  }
  removeLang(index: number) {
    this.translate.removeAt(index);
  }

  // close() {
  //   this.dialogRef.close();
  // }

  // getTranslationLabelById() {
  //   let postOption = {
  //     organizationid: localStorage.getItem("crm_orgid"),
  //     // domain: localStorage.getItem("domain"),
  //     // subdomain: localStorage.getItem("subdomain"),
  //     domain: localStorage.getItem(
  //       `${localStorage.getItem("crm_orgid")}.domain`
  //     ),
  //     subdomain: localStorage.getItem(
  //       `${localStorage.getItem("crm_orgid")}.subdomain`
  //     ),
  //     data: {
  //       metabuttonlabeltranslation: {
  //         metabuttonid: this.metalayoutId,
  //       },
  //     },
  //   };

  //   this.isLoading = true;
  //   this.dataService.getButtonTranslationLabelById(postOption).subscribe(
  //     (res) => {
  //       //alert('****res****' + JSON.stringify(res));
  //       console.log(res);
  //       if (res.success == 1) {
  //         // Loop through the response and add translation fields
  //         if (res.data.metabuttonlabeltranslation) {
  //           this.translate.clear();
  //           res.data.metabuttonlabeltranslation.forEach((translation) => {
  //             const translateGroup = this.formBuilder.group({
  //               languageCode: [translation.languagecode, Validators.required],
  //               translatedName: [
  //                 translation.translatedlabel,
  //                 Validators.required,
  //               ],
  //             });
  //             this.translate.push(translateGroup);
  //           });
  //           // After populating translateForm, update translatedLabels
  //           this.translatedLabels = res.data.metabuttonlabeltranslation.map(
  //             (translation) => ({
  //               languageCode: translation.languagecode,
  //               translatedName: translation.translatedlabel,
  //             })
  //           );
  //         }
  //         this.isLoading = false;
  //       } else {
  //         console.log("no data");
  //         this.isLoading = false;
  //       }
  //     },
  //     (err) => {
  //       console.log("Error***:", err);
  //       this.errorMessage = err.message;
  //       this.isError = true;
  //       this.isLoading = false;
  //       //this.resetDetailFormControls();
  //     }
  //   );
  // }

  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000
    };
    this.toastrService.success(data, "", options);
  }

  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Application Error!", options);
  }

  showWarning(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-bottom-right",
      messageClass: "orange darken-4",
      toastClass: "warning-color-dark"
    };
    this.toastrService.warning(data, "", options);
  }
  parent: any;

  setParent(parent: any) {
    this.parent = parent;
  }

  submit() {
    if (this.detailForm.invalid) {
      this.showWarning("Please fill in all required fields");
      return;
    }
    const Name = this.detailForm.controls["name"].value;
    const displayName = this.detailForm.controls["displayname"].value;
    const editDisplayName = this.detailForm.controls["editdisplayname"].value;
    const fieldHistory = this.detailForm.controls["fieldhistory"].value;
    const approvalHistory = this.detailForm.controls["approvalhistory"].value;
    const activity = this.detailForm.controls["activity"].value;
    const notesandattachments =
      this.detailForm.controls["notesandattachments"].value;
    const followup = this.detailForm.controls["followup"].value;
    const Team = this.detailForm.controls["team"].value;
    const pathSetting = this.detailForm.controls["pathsetting"].value;
    const processbartype = this.detailForm.controls["processbartype"].value;
    const category = this.detailForm.controls["category"].value;
    const devicetype = this.detailForm.controls["devicetype"].value;
    const sinceversionseq =
      this.detailForm.controls["sinceversionseq"].value != null
        ? this.detailForm.controls["sinceversionseq"].value
        : 0;
    const deprecatedversionseq =
      this.detailForm.controls["deprecatedversionseq"].value != null
        ? this.detailForm.controls["deprecatedversionseq"].value
        : 0;

    this.parent.receiveEnteredName(
      Name,
      displayName,
      editDisplayName,
      fieldHistory,
      approvalHistory,
      activity,
      notesandattachments,
      followup,
      Team,
      pathSetting,
      processbartype,
      category,
      devicetype,
      sinceversionseq,
      deprecatedversionseq
    );

    console.log("followup", followup);
    this.dialogRef.close();
  }

  close() {
    this.dialogRef.close();
  }
}
